import { format } from 'date-fns';
import type jsPDF from 'jspdf';
import type { CellDef } from 'jspdf-autotable';

export function addHeader(doc: jsPDF, title: string) {
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(8);
  doc.text(
    format(new Date(), 'P') + '\n' + format(new Date(), 'p'),
    pageWidth - 15,
    10,
    {
      align: 'right',
    },
  );
  doc.text('Löwenstein Medical Technology', 15, 10, {
    align: 'left',
  });

  doc.setFontSize(16);
  doc.setFont('Arial', 'underline', 'bold');
  doc.text(title, pageWidth / 2, 10, {
    align: 'center',
  });
}
export function fieldTitleCell(title: string): CellDef {
  return { content: title, styles: { fontStyle: 'bold' } };
}
